import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MerchProductsView } from "../../components/merch/products-view";
import { listSearch } from "../../lib/list-page/list-search";

/** Merchandising › Products: offset pages (the catalogue is capped), `search` (→ the API's `q`) and `active` in the URL. */
export const Route = createFileRoute("/_app/merchandising/products/")({
	validateSearch: listSearch(["position"] as const, { active: z.enum(["true", "false"]) }),
	component: ProductsPage,
});

function ProductsPage() {
	return <MerchProductsView search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
